module.exports = __webpack_public_path__ + "static/media/c4me.457c972f.png";